import { createGlobalStyle } from 'styled-components';

import { SEMANTIC_COLORS } from '@/constant/unit/color';

export const GlobalStyle = createGlobalStyle`
/* Reset CSS */

/* http://meyerweb.com/eric/tools/css/reset/ 
   v2.0 | 20110126
   License: none (public domain)
*/
html,
body,
div,
span,
p,
a,
button,
img,
strong,
li,
label {
  padding: 0;
  margin: 0;
  vertical-align: baseline;
  border: 0;
}

/*! normalize.css v8.0.1 | MIT License | github.com/necolas/normalize.css */

/**
 * 1. Correct the line height in all browsers.
 * 2. Prevent adjustments of font size after orientation changes in iOS.
 */
html {
  line-height: 1.15; /* 1 */
  color: ${SEMANTIC_COLORS.DEFAULT_TEXT};
  text-size-adjust: 100%; /* 2 */
}

*,
*::before,
*::after {
  box-sizing: border-box;
  -webkit-tap-highlight-color: transparent; /* fix the highlight-color in safari */
}

a {
  text-decoration: none;
}

/* unify the marker size in our apps */
li::marker {
  font-size: 12px;
}

/**
 * 1. Change the font styles in all browsers.
 * 2. Remove the margin in Firefox and Safari.
 */
button,
input,
select,
textarea {
  margin: 0; /* 2 */
  font-family: inherit; /* 1 */
  font-size: 100%; /* 1 */
  line-height: 1.15; /* 1 */
  appearance: none;
}

div,
textarea,
span,
p,
li,
strong,
input,
a {
  /* 1. handle overflowing texts */

  /* for browsers that do not support overflow-wrap: anywhere */
  word-break: break-all;
  overflow-wrap: break-word;

  overflow-wrap: anywhere;

  /* 2. handle line breaks */
  white-space: pre-wrap;
}
`;
